/*
 * Pestaña Proyecto de la cuenta: sus proyectos, con fase, plan e indicador, y el
 * salto al espacio del proyecto (/proyectos/:id). Solo se muestra cuando hay uno.
 */

import { useNavigate } from "react-router-dom";

import { FASES_PROYECTO, type CuentaDetalle } from "../../api/tipos";
import { useFormularios } from "../../shell/Formularios";
import { Abierto, CabeceraSeccion } from "../../ui/primitivas";
import { PillKpi, estadoKpi, estadoPlan } from "../../ui/proyecto";

export function ProyectoTab({ c }: { c: CuentaDetalle }) {
  const nav = useNavigate();
  const { abrir } = useFormularios();
  const proys = c.proyectos;
  return (
    <div style={{ maxWidth: 900 }}>
      <CabeceraSeccion titulo="Proyectos" n={proys.length} />
      {proys.length === 0 && <Abierto>Sin proyecto. Se crea al aceptar una propuesta.</Abierto>}
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {proys.map((p) => {
          const st = estadoKpi(p), plan = estadoPlan(p);
          return (
            <div key={p.id} className="tarjeta" style={{ display: "grid", gridTemplateColumns: "1fr auto", gap: "6px 24px", alignItems: "center", padding: "16px 20px" }}>
              <button onClick={() => nav(`/proyectos/${p.id}`)} style={{ minWidth: 0 }}>
                <span className="subtitulo" style={{ display: "block" }}>{p.nombre}</span>
                <span style={{ display: "block", fontSize: 13, color: "var(--muted)", marginTop: 2 }}>
                  {p.estado === "por_arrancar" ? "Propuesta aceptada · arranca al firmar baseline" : <>{FASES_PROYECTO[p.fase]?.nombre} · <span style={{ color: plan.color, fontWeight: 500 }}>{plan.label}</span></>}
                </span>
              </button>
              <span style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", justifyContent: "flex-end" }}>
                <span style={{ fontSize: 12.5, color: "var(--muted)" }}>{p.indicador.nombre}</span>
                <PillKpi st={st} />
                {p.estado === "por_arrancar"
                  ? <button className="btn btn-primario" onClick={() => abrir({ tipo: "arrancar", cuentaId: c.id, proyectoId: p.id, nombre: p.nombre, empresa: c.empresa })}>Arrancar</button>
                  : <button className="btn btn-fantasma" onClick={() => nav(`/proyectos/${p.id}`)}>Abrir →</button>}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
